import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import ConfirmationDialog from 'components/legacy/ConfirmationDialog';
import { fromApiBoolean } from '@liquidweb-dev/club-sauce/types/boolean';
import useProjectRename from 'modules/queries/project/useRename';
import toast from '@liquidweb-dev/undercurrent/toast';
import useDebounce from 'utility/effects/useDebounce';
import useProjectAvailable from 'modules/queries/project/useAvailable';
import { selectors } from 'modules/renameProjectDialog/selectors';
import actions from 'modules/renameProjectDialog/actions';

const EditNameDialog = () => {
	const dispatch = useDispatch();

	const isOpen = useSelector(selectors.isOpen);
	const dialogProps = useSelector(selectors.dialogProps);
	const { projectId, projectName } = dialogProps;

	const [newProjectName, setNewProjectName] = useState(projectName);
	const debouncedNewProjectName = useDebounce(newProjectName, 500);

	const isEnabledProjectAvailable =
		Boolean(debouncedNewProjectName) && debouncedNewProjectName !== projectName;

	const { data: projectAvailableData, isLoading: isLoadingProjectAvailable } =
		useProjectAvailable(
			{ project_name: debouncedNewProjectName },
			{
				enabled: isEnabledProjectAvailable,
			},
		);

	const { mutate: renameProject, isLoading: isLoadingRename } =
		useProjectRename();

	const toggleDialog = (value) => dispatch(actions.toggleDialog(value));

	useEffect(() => {
		setNewProjectName(projectName);
	}, [projectName]);

	const handleChangeName = (e) => {
		setNewProjectName(e.target.value);
	};

	const notAvailable =
		projectAvailableData && !fromApiBoolean(projectAvailableData?.available);

	return (
		<ConfirmationDialog
			open={isOpen}
			confirmProps={{
				disabled: notAvailable || !newProjectName,
				isLoading:
					isLoadingRename ||
					(isEnabledProjectAvailable && isLoadingProjectAvailable),
			}}
			onConfirm={() =>
				renameProject(
					{ new_project_name: newProjectName, id: projectId },
					{
						onSuccess: () => {
							toast.success('Successfully renamed project');
						},
					},
				)
			}
			onClose={() => {
				toggleDialog(false);
				setNewProjectName(projectName);
			}}
			title="Edit Project Name"
		>
			<TextField
				error={notAvailable}
				helperText={notAvailable && 'Project name not available'}
				value={newProjectName}
				label="Project Name"
				variant="outlined"
				onChange={handleChangeName}
			/>
		</ConfirmationDialog>
	);
};

export default EditNameDialog;
